/**
 * Clock for app-modal scheduling.
 * Override via `?mockDate=2026-07-29` (or any Date-parseable string).
 */
export function getAppNow(): Date {
  if (typeof window !== "undefined") {
    const raw = new URLSearchParams(window.location.search).get("mockDate")
    if (raw) return new Date(raw)
  }
  return new Date()
}
